module.exports = __webpack_public_path__ + "static/media/room-5.ec228746.jpg";